export default "__VITE_ASSET__BMvR$OWB__"